import React, { useRef, Children, cloneElement, forwardRef, useImperativeHandle, isValidElement } from 'react';
import { FormContainer } from './LeadForm.style';

const LeadForm = forwardRef<any, { children: any }>((props, ref) => {
    const itemRefs = useRef<any[]>([]);

    useImperativeHandle(ref, () => ({
        validate: () => {
            let valid = true;
            itemRefs.current.forEach((itemRef) => {
                if (itemRef && itemRef.validate && !itemRef.validate()) valid = false;
            });
            return valid;
        },
        getValues: () => {
            const values: Record<string, string> = {};
            itemRefs.current.forEach((itemRef) => {
                if (itemRef && itemRef.getValue && itemRef.props && itemRef.props.name) {
                    values[itemRef.props.name] = itemRef.getValue();
                }
            });
            return values;
        },
    }));

    const childrenWithRef = Children.map(props.children, (child, idx) => {
        if (!isValidElement(child)) {
            return null;
        }
        
        return cloneElement(child as React.ReactElement<any>, { ref: (el: any) => (itemRefs.current[idx] = el) });
    });

    return <FormContainer>{childrenWithRef}</FormContainer>;
});

LeadForm.displayName = 'LeadForm';

export default LeadForm;
